import { Component, OnDestroy, OnInit } from '@angular/core';
import { DataService, HelperService } from 'app/services';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subscription } from 'rxjs/internal/Subscription';
import { lowerCase } from 'lodash';
@Component({
  selector: 'app-tire-dot-number-dialog',
  templateUrl: './tire-dot-number-dialog.component.html',
  styleUrls: ['./tire-dot-number-dialog.component.scss']
})
export class TireDotNumberDialogComponent implements OnInit, OnDestroy {

  tirePositions = [
    {
      label: 'Front Left',
      labelFR: 'Avant gauche',
      value: 'FL',
    },
    {
      label: 'Front Right',
      labelFR: 'Avant droit',
      value: 'FR',
    },
    {
      label: 'Rear Left',
      labelFR: 'Arrière gauche',
      value: 'RL',
    },
    {
      label: 'Rear Right',
      labelFR: 'Arrière droit',
      value: 'RR',
    },
    {
      label: 'Spare',
      labelFR: 'De rechange', 
      value: 'S1'
    },
  ];
  data: any;
  defaultDots: any[];
  tires: any[] = [];
  highLightedTireId = '';
  isMultipleTires = false;
  unassignedServices: any = {};
  isUnassignedAvailable: boolean = false;
  isSalesCodeEnabled: boolean = false;
  dataSubscription: Subscription;
  currentLang: string = 'en';

  constructor(
    private dynamicDialogRef: DynamicDialogRef,
    private dConfig: DynamicDialogConfig,
    private dataService: DataService,
    private helperService: HelperService
  ) { }

  ngOnInit() {
    this.data = JSON.parse(JSON.stringify(this.dConfig.data));
    this.currentLang = lowerCase(this.data?.currentLang || 'en');
    this.isSalesCodeEnabled = this.dataService.isSalesCodeEnabled;
    if (this.data.isAllServiceItems) {
      this.data.tires.forEach(tire => {
        this.mapDotNumbersData(tire, this.data.isDotNumberReqOnInv);
      });
    } else if (this.data?.estimate?._id) {
      this.isMultipleTires = true;
      this.data?.estimate?.services?.forEach(service => {
        service?.items?.forEach(item => {
          if (item?.subItems?.length) {
            item?.subItems.forEach(subItem => {
              const count = subItem.count ? Math.abs(subItem.count) : 0;
              if (subItem.type === 'tire' && ((Number(count) && Number(count) !== subItem?.dotNumbers?.length) || (subItem.dotNumbers.some(dot => dot?.dotNumber === '')))) {
                const data = {
                  count: Number(subItem.count),
                  dotNumbers: subItem.dotNumbers ? subItem.dotNumbers : [],
                  positionPlaceholder: 'Tire Position',
                  dotNumberTitle: 'Tire DOT#',
                  title: subItem.title,
                  id: subItem._id
                }
                this.mapDotNumbersData(data)
                this.tires.push(data)
              }
            })
          } else {
            const count = item.count ? Math.abs(item.count) : 0;
            if (item.type === 'tire' && ((Number(count) && Number(count) !== item?.dotNumbers?.length) || (item.dotNumbers.some(dot => dot?.dotNumber === '')))) {
              const data = {
                count: Number(item.count),
                dotNumbers: item.dotNumbers ? item.dotNumbers : [],
                positionPlaceholder: 'Tire Position',
                dotNumberTitle: 'Tire DOT#',
                title: item.title,
                id: item._id
              }
              this.mapDotNumbersData(data)
              this.tires.push(data)  
            }
          }
        })
      })
    } else {
      this.mapDotNumbersData(this.data);
    }
    if (this.data.unassignedServices && Object.keys(this.data.unassignedServices)?.length) {
      this.unassignedServices = this.data.unassignedServices;
      this.isUnassignedAvailable = this.data.unassignedServices.unassignedServiceItems.reduce((acc, curr) => {
        if (!acc && curr.items?.length) {
          acc = true;
        }
        return acc;
      }, false)
    }
    this.dataSubscription = this.dataService.getData().subscribe((payload) => {
      if (payload.data && payload.data.key === 'authorization-dialog') {
        const assignedItems = payload.data.data.assignedSalesCodeItems.map(item => item.itemId);
        this.data.unassignedServices.unassignedServiceItems.forEach(service => {
          service.items = service.items.filter(item => !assignedItems.includes(item.itemId))
        })
        this.unassignedServices = this.data.unassignedServices;
        this.isUnassignedAvailable = this.data.unassignedServices.unassignedServiceItems.reduce((acc, curr) => {
          if (!acc && curr.items?.length) {
            acc = true;
          }
          return acc;
        }, false);
        if (!this.isUnassignedAvailable && !this.tires.length) {
          this.closeDialog('close')
        }
        this.dataSubscription.unsubscribe();
      }
    });
  }

  mapDotNumbersData(data, flag = false) {
    if (data.dotNumbers.length > 0) {
      data.dotNumbers.forEach(element => {
        element.tirePosition = { label: this.getTireLabel(element.tirePosition), value: element.tirePosition }
        if (!element.dotNumber) {
          element.tooltip = 'Please enter DOT# to specify tire position';
          if (flag) element.isInvalid = true;
        }
      });
    }
    const count = data.count < 0 ? data.count * -1 : data.count;
    if (data.dotNumbers.length < count) {
      const newDotNumbers = count - data.dotNumbers.length;
      for (var i = 0; i < newDotNumbers; i++) {
        const item: any = { dotNumber: '', tirePosition: '', tooltip: 'Please enter DOT# to specify tire position' };
        if (flag) item.isInvalid = true;
        data.dotNumbers.push(item);
      }
    }
  }

  getTireLabel(value: string): string {
    let tireHeaderTitle: string = '';
    switch (value) {
      case 'FL': {
        tireHeaderTitle = 'Front Left';
        break;
      }
      case 'FR': {
        tireHeaderTitle = 'Front Right';
        break;
      }
      case 'RL': {
        tireHeaderTitle = 'Rear Left';
        break;
      }
      case 'RR': {
        tireHeaderTitle = 'Rear Right';
        break;
      }
      case 'S1': {
        tireHeaderTitle = 'Spare';
        break;
      }
      case 'S2': {
        tireHeaderTitle = 'Spare';
        break;
      }
    }

    return tireHeaderTitle;
  }

  closeDialog(type) {
    // this.data.dotNumbers.forEach(element => {
    //   element.tirePosition = element.tirePosition?.value || '';
    // });
    if(type === 'close') this.dynamicDialogRef.close({ isSuccess: false });
    if(type === 'skip') this.dynamicDialogRef.close({ isSuccess: false, skip: true });
  }

  saveTireDotNumbers() {
    if (this.data.isAllServiceItems) {
      if(this.validateDotNumbers()) this.dynamicDialogRef.close({ isSuccess: true, tires: this.data.tires });
    } else {
      this.dynamicDialogRef.close({ isSuccess: true, dotNumbers: this.isMultipleTires ? this.tires : this.data.dotNumbers });
    }
    
  }
  
  onCardTypeSelect(event, item) {
    if (item.tirePosition && item.tirePosition.value === event?.value) {
      item.tirePosition = '';
    } else {
      item.tirePosition = event;
    }

  }

  handleChange(event, item) {
    item.dotNumber = event;
    const pattern = /^(?!\s+$).*/;
    if (item.dotNumber === '' || !pattern.test(item.dotNumber)) {
      item.tooltip = 'Please enter DOT# to specify tire position';
      item.isInvalid = true;
    }
    else {
      item.tooltip = '';
      item.isInvalid = false;
    }
  }

  validateDotNumbers() {
    let isValid = true;
    this.data.tires.forEach((tire) => {
      tire.dotNumbers.forEach(element => {
        if (this.data.isDotNumberReqOnInv) {
          if (element.isInvalid) {
            isValid = false;
            return;
          }
        }else{
          if(!element.dotNumber || element.dotNumber.trim() === '') {
            element.isInvalid = true;
            isValid = false;
          }
        }
        // element.tirePosition = element.tirePosition.value;
        // if (element.tooltip) delete element.tooltip;
        // if (element.isInvalid) delete element.isInvalid;
        // if (!element.dotNumber) element.tirePosition = '';
      });
    });
    return isValid;
  }

  openAssignAllSalesCodeModal() {
    this.dataService.sendData(
      this.dataService.typeDialog('open-sales-code-assign-modal', 'authorization-dialog', null, null, {
        isShowMultipleView: true,
        orderId: this.data?.estimate._id,
        openFrom: 'authorization-dialog',
        unassignedServices: this.helperService.deepCopy(this.unassignedServices.unassignedServiceItems),
        skippedItems: this.helperService.deepCopy(this.unassignedServices.skippedItems),
      }),
    );
  }

  ngOnDestroy(): void {
    this.dataSubscription.unsubscribe();
  }
}
